import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment Comment on exercise_comments {
    id
    comment_text
    created_at
    user_id
    user {
      user_first_name
      user_last_name
      user_type
    }
  }
`;

export const GET_COMMENTS = gql`
  query getComments($exerciseId: Int!) {
    comments: exercise_comments(
      where: { student_exercise_id: { _eq: $exerciseId } }
      order_by: [{ created_at: asc }]
    ) {
      ...Comment
    }
  }
  ${FRAGMENTS}
`;

export const ADD_COMMENT = gql`
  mutation addComment($input: [exercise_comments_insert_input!]!) {
    comments: insert_exercise_comments(objects: $input) {
      returning {
        ...Comment
      }
    }
  }
  ${FRAGMENTS}
`;
